<template>
    <main class="mb-5 pb-5">
        <div class="my-8">
            <h1 class="text-3xl">Crear usuario</h1>
        </div>

        <div>
            <div class="flex flex-wrap mt-5 gap-y-4">
                <div class="w-full md:w-1/2 px-2">
                    <custom-input
                        v-model="itemComponent.firstName"
                        label="Nombres"
                        :error="
                            !isValidFirstName && introValidators.firstName
                                ? 'Nombres no validos'
                                : ''
                        "
                        @blur="introValidators.firstName = true"
                    />
                </div>

                <div class="w-full md:w-1/2 px-2">
                    <custom-input
                        v-model="itemComponent.lastName"
                        label="Apellidos"
                        :error="
                            !isValidLastName && introValidators.lastName
                                ? 'Apellidos no validos'
                                : ''
                        "
                        @blur="introValidators.lastName = true"
                    />
                </div>

                <div class="w-full md:w-1/2 px-2">
                    <custom-input
                        v-model="itemComponent.email"
                        label="Email"
                        :error="
                            !isValidEmail && introValidators.email
                                ? 'Email no es valido'
                                : ''
                        "
                        @blur="introValidators.email = true"
                    />
                </div>

                <div class="w-full md:w-1/2 px-2">
                    <role-selector v-model="itemComponent.roles" />
                </div>

                <div class="w-full md:w-1/2 px-2">
                    <custom-input
                        v-model="itemComponent.phone"
                        label="Celular de contacto"
                        type="number"
                    />
                </div>
            </div>
            <div class="flex justify-center my-4">
                <app-button @click="createUserComponent">
                    Crear usuario
                </app-button>
            </div>
        </div>
    </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { emailRegex, nameRegex, phoneRegex } from "@/common/lib/regex";

import RoleSelector from "@/components/roles/RoleSelector.vue";
import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "DetailUsers",
    components: {
        RoleSelector,
        CustomInput
    },
    data: () => ({
        itemComponent: {
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            roles: []
        },
        introValidators: {
            firstName: false,
            lastName: false,
            email: false,
            phone: false
        },
        isLoading: false
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"]),
        isValidEmail() {
            return emailRegex.test(this.itemComponent.email);
        },
        isValidFirstName() {
            return (
                nameRegex.test(this.itemComponent.firstName) &&
                this.itemComponent.firstName
            );
        },
        isValidLastName() {
            return (
                nameRegex.test(this.itemComponent.lastName) &&
                this.itemComponent.lastName
            );
        },
        isValidPhone() {
            return (
                this.itemComponent.phone === "" ||
                phoneRegex.test(this.itemComponent.phone)
            );
        }
    },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        await verifyPagePermission("user:Create", "/app/users");
    },
    methods: {
        ...mapActions("users", ["createUser"]),
        async createUserComponent() {
            if (!this.validateData()) {
                return;
            }
            this.isLoading = true;
            this.$loading.show();
            try {
                const { id, wasSendedInvitation } = await this.createUser(
                    this.getDataSend()
                );
                this.$analytics.trackEvent("user_invited", {
                    invitation_sent: !!wasSendedInvitation,
                    roles_count: this.itemComponent.roles.length
                });
                this.$loading.hide();
                this.itemComponent = { ...this.itemComponent, id };
                this.$sound.play();
                const dialogResult = await this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Creación exitosa",
                    text: `Id: ${id}${
                        wasSendedInvitation
                            ? "\nSe ha enviado el correo de invitación al usuario."
                            : ""
                    }`,
                    icon: "success",
                    showDenyButton: true,
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonColor: "#02672D",
                    cancelButtonColor: "#253C99",
                    denyButtonColor: "#d33ddd",
                    confirmButtonText: "Ver detalle",
                    denyButtonText: "Ir a lista de usuario",
                    cancelButtonText: "Registrar nuevo usuario"
                });
                if (dialogResult.isConfirmed) {
                    this.id = id;
                    this.itemComponent = { ...this.itemComponent, id };
                    this.$router.push(`/app/users/detail/${id}`);
                }
                if (dialogResult.isDenied) {
                    this.$router.push("/app/users");
                }
                if (dialogResult.isDismissed) {
                    this.introValidators = {
                        slug: false,
                        name: false,
                        summary: false
                    };
                    this.itemComponent = {
                        firstName: "",
                        lastName: "",
                        email: "",
                        phone: "",
                        roles: []
                    };
                }
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.isLoading = false;
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        validateData() {
            const toComplete = [];
            if (!this.isValidEmail) {
                toComplete.push("Email");
            }
            if (!this.isValidFirstName) {
                toComplete.push("Nombre");
            }

            if (!this.isValidLastName) {
                toComplete.push("Apellido");
            }

            if (!this.isValidPhone) {
                toComplete.push("Teléfono");
            }

            if (!this.itemComponent.roles.length) {
                toComplete.push("Selección de rol");
            }

            if (toComplete.length) {
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Usuario invalido",
                    text: `Revisa por favor que todo este completo. Valida los siguientes campos: ${toComplete.join(
                        ", "
                    )}`,
                    icon: "info"
                });
                return false;
            }
            return true;
        },
        getDataSend() {
            return {
                ...this.itemComponent,
                rolesSlugs: this.itemComponent.roles.map((item) => item.slug)
            };
        }
    }
};
</script>
